import { Contact } from 'components/Contact';
import { ContentHero } from 'components/ContentHero';
import { Page } from 'components/Page';
import { RelatedItemsWrapper } from 'components/RelatedItems';
import { Slices } from 'components/Slices';
import { SpacingSection } from 'components/SpacingSection';

export const ContentPage = ({ doc, preview }) => {
  const {
    seo_title,
    seo_description,
    seo_image,
    hero_type,
    hero_image,
    hero_text,
    hero_title,
    body,
    contact_title,
    contact_email,
    contact_tel,
    contact_whatsapp,
    related_items,
    related_items_title,
  } = doc.data;

  const renderContact =
    contact_title || contact_email || contact_tel || contact_whatsapp;
  const renderHero =
    hero_type || hero_image?.alt || hero_image?.src || hero_title || hero_text;
  const renderRelated = related_items?.length > 0 || related_items_title;
  const renderSlices = body?.length > 0;

  return (
    <Page
      description={seo_description}
      image={seo_image}
      preview={preview}
      title={seo_title}
      withLightFooter={renderContact && !renderRelated}
    >
      {renderHero && (
        <ContentHero
          image={{ alt: hero_image.alt, src: hero_image.url }}
          text={hero_text}
          title={hero_title}
          type={hero_type}
        />
      )}
      {renderSlices && <Slices data={body} uid={doc.uid} />}
      {renderContact && (
        <Contact
          title={contact_title}
          email={contact_email}
          tel={contact_tel}
          whatsapp={contact_whatsapp}
        />
      )}
      {renderRelated && (
        <SpacingSection>
          <RelatedItemsWrapper
            related_items={related_items}
            related_items_title={related_items_title}
          />
        </SpacingSection>
      )}
    </Page>
  );
};
